module.exports = "<div class=gmw-radio-container> <div class=gmw-radio ng-disabled=gmwDisabled ng-class=\"{\n      'gmw-radio--checked': checked,\n      'gmw-radio--small': small,\n    }\"> </div> <span class=gmw-radio-container__data ng-if=label> <span class=gmw-radio-container__label ng-class=\"{\n        'h-dark-text': checked,\n      }\" ng-bind=label> </span> <ng-transclude></ng-transclude> </span> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/holding/modules/app/modules/common/directives/radio-option/radio-option.html
// module id = 294
// module chunks = 0